module.exports = __webpack_public_path__ + "img/CI.6bf90550.svg";